const EXPECTED_REGEX_LENGTH = 3;

/**
 * Parses regex string and creates RegExp instance from it. This is needed to proper handle flags in the string: "/xxx/g".
 *
 * @param regexStr regex string in /(.*)/(.*) format - output of /xxx/g.toString()
 * @return instance of RegExp
 */
export function parseRegExpFromString(regexStr: string): RegExp {
    const parts = /\/(.*)\/(.*)/.exec(regexStr);
    if (!parts || parts.length < EXPECTED_REGEX_LENGTH) {
        throw new Error('Invalid regex');
    }
    return new RegExp(parts[1], parts[2]);
}
